// extracted by mini-css-extract-plugin
module.exports = {"card":"PriceTooLow_card__1TID0","paragraph":"PriceTooLow_paragraph__1hZ4Z"};